import React from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { Button as MuiButton, Typography } from "@mui/material";
import { spacing } from "@mui/system";
import { fontFamily } from "../../design-system/tokens";

const Button = styled(MuiButton)(spacing);

const Wrapper = styled.div`
  text-align: center;
`;

/**
 * 403 Forbidden — shown by PermissionGuard when the caller lacks the
 * required permission for a route. Opaque message in production; the
 * missing permission key is shown only in development to help during
 * implementation. (Ref: LWI-661 / Permissions Refactor §"403 page UX".)
 */
function Forbidden({ missingPermission }) {
  const isDev = import.meta.env.DEV;

  return (
    <Wrapper>
      <Helmet title="403 Forbidden" />
      <Typography component="h1" variant="h1" align="center" gutterBottom>
        403
      </Typography>
      <Typography component="h2" variant="h4" align="center" gutterBottom>
        You don&apos;t have access to this page.
      </Typography>
      <Typography
        component="h2"
        variant="subtitle1"
        align="center"
        gutterBottom
      >
        If you believe this is an error, ask an administrator to grant you the
        required permission.
      </Typography>

      {isDev && missingPermission ? (
        <Typography
          component="pre"
          variant="caption"
          align="center"
          color="text.secondary"
          sx={{ mt: 2, fontFamily: fontFamily.mono }}
        >
          [dev] Missing permission: {String(missingPermission)}
        </Typography>
      ) : null}

      <Button
        component={Link}
        to="/"
        variant="contained"
        color="secondary"
        mt={2}
      >
        Return to dashboard
      </Button>
    </Wrapper>
  );
}

export default Forbidden;
